import config from '../nyConfig'
const ApiRule = {
    "添加规则": new config({ url: '/assess/ruleAdd', showSuccessMessage: true, useToken: true }),
    "修改规则": new config({ url: '/assess/ruleEdit', showSuccessMessage: true, useToken: true }),
    "量表规则列表": new config({ url: '/assess/ruleList', showSuccessMessage: false, useToken: true }),
    "结果规则列表": new config({ url: '/assess/resultList', showSuccessMessage: false, useToken: true }),
    "添加结果规则": new config({ url: '/assess/resultAdd', showSuccessMessage: true, useToken: true }),
    "编辑结果规则": new config({ url: '/assess/resultEdit', showSuccessMessage: true, useToken: true }),
    "删除结果规则": new config({ url: '/assess/delReslut', showSuccessMessage: true, useToken: true }),
}

export default ApiRule